import { ComponentProps, FC } from 'react';
import { TbArrowsMerge } from 'react-icons/tb';

type MergeIconProps = ComponentProps<typeof TbArrowsMerge>;

const MergeIcon: FC<MergeIconProps> = ({ size = '1rem', style, ...props }) => (
    <TbArrowsMerge
        {...props}
        size={size}
        style={{
            ...style,
            transform: 'rotate(90deg)',
            transformOrigin: 'center',
        }}
    />
);

export default MergeIcon;
